import { RouteScroller } from "@client/components/utils/RouteScroller";
import {
  BookOpen,
  FilePenLine,
  ClipboardCheck,
  ChartNoAxesCombined,
} from "lucide-react";
import { LoginPanel } from "./LoginButton";
import "./welcomeLanding.css";

const uses = [
  {
    icon: FilePenLine,
    title: "Apply for funding",
    description: "Tell us about your organization and the work you want to do.",
  },
  {
    icon: ClipboardCheck,
    title: "Check your application",
    description: "Return to your application and see where things stand.",
  },
  {
    icon: BookOpen,
    title: "Review applications",
    description:
      "Recommenders: explore applications and share your assessments.",
  },
  {
    icon: ChartNoAxesCombined,
    title: "Manage funding",
    description:
      "Funders: review recommendations and manage your funding rounds.",
  },
];

export function WelcomeLanding({ error }: { error?: string }) {
  return (
    <RouteScroller className="bg-background">
      <main className="mx-auto flex min-h-full max-w-7xl flex-col px-6 py-8 md:px-12 md:py-16">
        <div className="grid flex-1 items-center gap-10 lg:grid-cols-2 lg:gap-20">
          <section className="max-w-lg">
            <p className="mb-4 body-md text-muted-foreground">
              Survival &amp; Flourishing Fund
            </p>
            <h1 className="welcome-headline text-4xl leading-none tracking-[-0.03em] md:text-5xl">
              Empowering organizations to secure humanity’s future
            </h1>
            <p className="mt-6 max-w-md body-lg text-muted-foreground">
              Apply for funding, follow your application, or help decide which
              work to support.
            </p>
            <ul className="mt-10 hidden space-y-6 lg:block">
              {uses.map(({ icon: Icon, title, description }) => (
                <li key={title} className="flex items-start gap-4">
                  <Icon
                    className="mt-1 size-4 shrink-0 text-muted-foreground"
                    aria-hidden="true"
                  />
                  <div>
                    <h2 className="label-lg">{title}</h2>
                    <p className="mt-1 body-md text-muted-foreground">
                      {description}
                    </p>
                  </div>
                </li>
              ))}
            </ul>
          </section>

          <section
            aria-labelledby="welcome-sign-in"
            className="w-full max-w-lg rounded-xl border border-border bg-card p-6 sm:p-10 lg:justify-self-end"
          >
            <h2 id="welcome-sign-in" className="heading-lg">
              Welcome to S-Process
            </h2>
            <p className="mb-8 mt-2 body-md text-muted-foreground">
              Your applications and funding rounds, in one place.
            </p>
            <LoginPanel variant="welcome" />
            {error && (
              <p role="alert" className="mt-4 body-md text-destructive">
                Error: {error}
              </p>
            )}
          </section>
        </div>
        <footer className="mt-10 body-sm text-muted-foreground">
          <a
            href="https://survivalandflourishing.fund/"
            className="rounded-sm underline underline-offset-4 hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-ring"
          >
            Learn about Survival &amp; Flourishing Fund ↗
          </a>
        </footer>
      </main>
    </RouteScroller>
  );
}
